import React from "react";
import { BsPatchCheckFill } from "react-icons/bs";


const Experience = () => {
  return (
    <div className="bg-indigo-800 w-full lg:h-screen lg:pt-18  gap-2 pt-20 pb-20  ">
      <div className="items-center flex flex-col gap-1 ">
        <span className=" py-1 px-7 bg-gradient-to-r from-indigo-500 ... w-auto h-auto rounded-lg text-white text-xs mt-2">
          What skills I have...
        </span>
        <div className=" bg-pink-600 w-auto h-9 rounded-lg text-white  text-center pt-1  text-lg   ">
          My Experience
        </div>
      </div>
      <div className=" flex flex-col items-center md:flex-row md:items-center md:justify-center">
      
      <div className="px-5 mt-6 border-2 border-pink-600 hover:border-white /80 mx-6  flex flex-col  rounded-xl py-4 cursor-pointer transition ease-in-out delay-150 bg-indigo-900 hover:-translate-y-1 hover:scale-80 hover:bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 duration-300  w-60">
        <article className="experience_details text-white flex flex-col"><h3 className="text-white ml-6 mt-2 flex items-center justify-center my-4">Front-end Development</h3>
          <BsPatchCheckFill className="fill-white" />
          <h2 className="">HTML</h2>
          <small className="text-white/75">Experienced</small>
        </article>
        <article className="experience_details text-white flex flex-col">
          <BsPatchCheckFill className="fill-white" />
          <h2 className="">CSS</h2>
          <small className="text-white/75">Experienced</small>
        </article>
        <article className="experience_details text-white flex flex-col">
          <BsPatchCheckFill className="fill-white" />
          <h2 className="">Bootsrap</h2>
          <small className="text-white/75">Experienced</small>
    
        </article>

        <article className="experience_details text-white flex flex-col">
          <BsPatchCheckFill className="fill-white" />
          <h2 className="">JavaScript</h2>
          <small className="text-white/75">Intermediate</small>
        </article>
        <article className="experience_details text-white flex flex-col">
          <BsPatchCheckFill className="fill-white" />
          <h2 className="">React JS</h2>
          <small className="text-white/75">Intermediate</small>
        </article>
        
       </div>

       

      
      
      
      <div className="px-5 mt-2 border-2 border-pink-600 hover:border-white  flex flex-col  rounded-xl py-4 cursor-pointer transition ease-in-out delay-150 bg-indigo-900 hover:-translate-y-1 hover:scale-80 hover:bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 duration-300  w-60">
        <article className="experience_details text-white flex flex-col"><h3 className="text-white ml-6 mt-2 flex items-center justify-center my-4">Back-end Development</h3>
          <BsPatchCheckFill className="fill-white" />
          <h2 className="">MongoDB</h2>
          <small className="text-white/75">Basic</small>
        </article>
        <article className="experience_details text-white flex flex-col">
          <BsPatchCheckFill className="fill-white" />
          <h2 className="">PHP</h2>
          <small className="text-white/75">Basic</small>
        </article>
        <article className="experience_details text-white flex flex-col">
          <BsPatchCheckFill className="fill-white" />
          <h2 className="">MySQL</h2>
          <small className="text-white/75">Intermediate</small>
        </article>

        
       </div>

      

      
      </div>
    </div>
  );
};

export default Experience;
